import React from 'react';

import PropTypes from 'prop-types';

import { Box, TopbarWrapper } from './css';
import ServiceListRow from './serviceListRow';
import { useLocalizedStringsContext } from '../../context/LocalizedStringsContext';

const ServiceList = ({
  contactCentreServices,
  setContactCentreServices,
  setEditService,
  setIsFormTouched,
  editService
}) => {
  const localizedStrings = useLocalizedStringsContext();
  const {
    callCentre: {
      labelServices,
      tableHeader: { labelServiceName, labelPrice, labelQuantity, labelActions }
    }
  } = localizedStrings;

  const removeService = id => {
    const updatedServicesList = contactCentreServices.filter(
      service => service.id !== id
    );
    setContactCentreServices(updatedServicesList);
    setIsFormTouched(true);
  };
  return (
    <Box>
      <TopbarWrapper>{`${labelServices} (${contactCentreServices.length})`}</TopbarWrapper>
      <table className="responsive-table">
        <thead className="responsive-table__thead">
          <tr>
            <th>#</th>
            <th>{labelServiceName}</th>
            <th>{labelPrice}</th>
            <th>{labelQuantity}</th>
            <th>{labelActions}</th>
          </tr>
        </thead>
        <tbody className="responsive-table__tbody">
          {contactCentreServices.map((item, index) => {
            const { id } = item;
            if (editService && id === editService) return null;
            return (
              <ServiceListRow
                key={id}
                rowData={item}
                setEditService={setEditService}
                removeService={removeService}
                index={index}
              />
            );
          })}
        </tbody>
      </table>
    </Box>
  );
};

ServiceList.propTypes = {
  contactCentreServices: PropTypes.arrayOf(PropTypes.any).isRequired,
  setContactCentreServices: PropTypes.func.isRequired,
  setEditService: PropTypes.func.isRequired,
  setIsFormTouched: PropTypes.bool.isRequired,
  editService: PropTypes.string.isRequired
};

export default ServiceList;
